import DOMPurify, { type Config } from 'dompurify'

// ─── HTML sanitizer for markdown rendered via dangerouslySetInnerHTML ────────────
//
// Assistant-turn markdown and opened documents are UNTRUSTED (the agent quotes
// WebFetch results / file contents verbatim), yet they go through marked.parse()
// straight into dangerouslySetInnerHTML. Without this, raw HTML / `javascript:`
// hrefs / <script> all execute, and since the JWT lives in localStorage, that is
// account takeover. Every dangerouslySetInnerHTML site MUST pass through here.
//
// DOMPurify defaults already strip script/style/iframe, all on* handlers, and
// non-http(s)/mailto URIs. We keep the defaults and only widen what our own
// markdown renderer legitimately needs:
//   • data-* attributes — our refactored md-link / copy-button markup carries its
//     behavior in data-attributes (no inline handlers anymore); a delegated
//     listener on the container reads them, so they must survive sanitization.
//   • class — used for code/diff styling and the md-link / md-prose-link classes.
const config: Config = {
  // Allow standard markdown-generated structure (DOMPurify's default ALLOWED_TAGS
  // already covers headings, lists, tables, code/pre, a, img, etc.). We rely on the
  // default tag allow-list and only forbid the dangerous ones explicitly for clarity.
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form'],
  // Strip every inline event handler. DOMPurify does this by default; listing it
  // makes the intent explicit and survives any future config drift.
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseenter', 'onmouseover'],
  ADD_ATTR: ['data-src', 'data-kind', 'data-chatid', 'data-mdpath', 'data-candidates', 'data-md-link', 'data-copy'],
  ALLOW_DATA_ATTR: true,
}

export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, config)
}
